import React from 'react'

// eslint-disable-next-line react/prop-types
export default function PublicRoute({ children }) {

  return <React.Suspense fallback={<>...</>}>{children}</React.Suspense>
}
